const TeknikDestek = resolve => {
    require.ensure(['../views/apps/teknikdestek/TeknikDestek'], () => {
        resolve(require('../views/apps/teknikdestek/TeknikDestek'))
    })
};
const TeknikDestekDetay = resolve => {
    require.ensure(['../views/apps/teknikdestek/TeknikDestekDetay'], () => {
        resolve(require('../views/apps/teknikdestek/TeknikDestekDetay'))
    })
};

import Vue from 'vue'
Vue.component('TeknikDestekDetay', TeknikDestekDetay);
import layouts from '../layout'

export default {
    path: '/teknikdestek',
    name: 'teknikdestek',
    component: TeknikDestek,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'teknikdestekdetay',
            component: TeknikDestekDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
